<template>
  <div style="background-color: lightgray" class="container">
    <div class="header-title">
        <span style="position: absolute;left: 2.2rem;top: 1.5rem;" @click="backUp"><van-icon name="revoke"></van-icon></span>
    收款地址
    </div>
    <div class="sub-continner" style="margin-top: 7.8rem;">
      <div class="main-card">
        <div class="main-card-content">
          方法：将钱包地址填写在下面点击保存即可！
          <div>提示：请仔细认真填写,切勿输错</div>
        </div>
      </div>
    <!--<van-row :gutter="0" style="background-color: white">
      <van-col :span="24">
        <div style="color: #44b1eb;margin: 5%;font-size: smaller;color: red">
          <div>
            <van-icon name="warning-o" />注意：该姓名必须与身份证设置的姓名一样！否则会引起提现失败。
          </div>
        </div>
      </van-col>
    </van-row>-->
    <van-form>
      <van-row :gutter="0">
        <van-col :span="24">
          <div style="min-height: 44px;line-height: 44px;color: darkgray;margin-top: 2%;font-size: smaller">
            <span style="margin-left: 5%;">提现收款信息</span>
          </div>
        </van-col>
      </van-row>
     <!-- <van-row :gutter="0" style="background-color: white">
        <van-col :span="24">
          <van-field
              readonly
              clickable
              :value="customer.backName"
              placeholder="选择收款信息"
              @click="showPicker = true"
              is-link
              :readonly="customer.status"
          />
          <van-popup v-model="showPicker" round position="bottom" v-if="!customer.status">
            <van-picker
                title="选择支付宝"
                show-toolbar
                :columns="backInfo"
                @confirm="onConfirm"
                @cancel="onCancel"
                @change="onChange"
            />
          </van-popup>
        </van-col>
      </van-row>
      <van-row :gutter="0" style="background-color: white" v-if="customer.backName != '支付宝'">
        <van-col :span="24">
          <van-field
              readonly
              clickable
              :value="customer.backOpenAdress"
              placeholder="选择开户行地址"
              @click="showAddrPicker = true"
              is-link
              :readonly="customer.status"
          />
          <van-popup v-model="showAddrPicker" round position="bottom" v-if="!customer.status">
            <van-area
                title="选择开户行地址"
                :area-list="backAddrInfo"
                ref="myArea"
                @confirm="onAddrConfirm"
                @cancel="onAddrCancel"
                @change="onAddrChange"
            />
          </van-popup>
        </van-col>
      </van-row>
            -->
      <van-row :gutter="0" style="background-color: white">
        <van-col :span="24">
          <van-field
              label="收款地址:"
              v-model="customer.backCardName"
              placeholder="请输入"
              :rules="[{ required: true, message: '付款信息' }]"
              >
          </van-field>
        </van-col>
      </van-row>
      <van-row :gutter="0" v-if="!customer.status">
        <van-col :span="24">
          <van-field
             label="确认地址:"
              v-model="customer.confirmBackCardName"
              placeholder="请输入">
          </van-field>
        </van-col>
      </van-row>
<!--
      :readonly="customer.status"
      <van-row :gutter="0" style="background-color: white">
        <van-col :span="24">
          <van-field
              v-model="customer.backCardNum"
              placeholder="USD地址"
              :rules="[{ required: true, message: 'USD地址' }]"
              :readonly="customer.status">
          </van-field>
        </van-col>
      </van-row>
      <van-row :gutter="0">
        <van-col :span="24">
          <div style="min-height: 44px;line-height: 44px;color: darkgray;margin-top: 2%;font-size: smaller">
            <span style="margin-left: 5%;">支付宝</span>
          </div>
        </van-col>
      </van-row>
      <van-row :gutter="0" style="background-color: white" type="flex">
        <van-cell :title="alipay"></van-cell>
            <div style="margin: 2%;padding-top: 2%;">
              <van-col :span="11" >
                <van-field name="holdIdCardUrl" v-if="!customer.status">
                  <template #input>
                    <van-uploader accept="image/*" :max-count="1" v-model="imageOneFile" :after-read="afterImages" >
                    </van-uploader>
                  </template>
                </van-field>
                <van-image
                    @click="perviewImage(customer.reciveMoneyCodeUrl)"
                    :src="customer.reciveMoneyCodeUrl" v-if="customer.status"></van-image>
              </van-col>
              <van-col :span="2" :style="{height:imgHeight}">
                <div style="padding: 16px 6px 1px;margin-left: 12px;border-left: 1px solid;font-size: 0;height: 93%"></div>
              </van-col>
              <van-col :span="11">
                <div ref="imgHeight">
                <van-image
                    @click="perviewImage(imageFour)"
                    :src="imageFour" ></van-image>
                </div>
              </van-col>
            </div>
      </van-row>-->
      
      <van-row :gutter="0">
        <van-col :span="24">
          <div style="min-height: 8%;line-height: 8%;color: darkgray;margin-top: 2%;font-size: smaller;height: 8%" >
          </div>
        </van-col>
      </van-row>
      <van-row :gutter="0" style="background-color: white;" v-if="!customer.status && customer.isOpenPayPassword">
        <van-col :span="24">
          <div style="display: flex;flex-flow: row nowrap;justify-content: space-around;">
          <van-field
              type="password"
              v-model="customer.moneyPassword"
              placeholder="请输入提现密码"
              :rules="[{ required: true, message: '请填提现密码' }]"
              :readonly="customer.status"
              style="width: 68%">
          </van-field>
          <mt-button type="text" style="float: right;line-height: 44px;color: red;font-size: smaller;" @click="resetPassword">没设置或忘记密码？</mt-button>
          </div>
        </van-col>
      </van-row>
      <!--<van-row :gutter="0" v-if="!customer.status">-->
        <van-row :gutter="0">
        <van-col :span="24">
          <div style="min-height: 44px;line-height: 44px;color: darkgray;margin-top: 2%;font-size: smaller; text-align: center;">
            <van-button type="info" style="margin: 5%;width: 200px;" @click.prevent="onSubmit(customer)">提交修改</van-button>
          </div>
        </van-col>
      </van-row>
      <!--<van-row :gutter="0" v-else>
        <van-col :span="24">
          <div style="min-height: 44px;line-height: 44px;color: darkgray;margin-top: 2%;font-size: smaller; text-align: center;">
            <van-button type="info" style="margin: 5%;width: 200px;" @click.prevent="updateReviewInfo">修改信息</van-button>
          </div>
        </van-col>
      </van-row>-->
    </van-form>
    </div>
  </div>
</template>

<script>
import {addBackCardData, getAllB2cBackInfos, getBackCard, uploaderToServer} from "../../api/system/sys_backInfo";
import {areaList} from "@vant/area-data";
import {Dialog, ImagePreview} from "vant";
import {MessageBox} from "mint-ui";
import {isStrEmpty} from "../../lib/utils";
import { mixins } from "../../mixins/mixins";

export default {
name: "ReciveMoney",
mixins: [mixins],
  data(){
  return {
    backType:"USD地址",
    alipay:"支付宝",
    customer:{
      backName:"支付宝",
      backOpenAdress:"",
      backCardName:"",
      backCardNum:"",
      reciveMoneyCodeUrl:"",
      moneyPassword:"",
      status:false,
    },
    showPicker: false,
    showAddrPicker:false,
    backInfo:[],
    backAddrInfo:areaList,
    imageOneFile:[],
    imageFour:"https://myb2c.oss-cn-hangzhou.aliyuncs.com/admin/wxpay.png",
    imgHeight:0
  }
  },
  mounted() {
    this.$emit("titleChange", "收款账号");
    getAllB2cBackInfos().then(res=>{
      if (res.success){
        this.backInfo = res.data.map(item=>item.backName);
      }
    });
    getBackCard().then(res=>{
      if (res.success && res.data != null){
        this.customer = res.data;
      }
    });
    setTimeout(()=>{ // 页面渲染完成后的回调
      console.log(this.$refs.imgHeight.offsetHeight)
      this.imgHeight = (parseInt(this.$refs.imgHeight.offsetHeight) - 3) + 'px';
    }, 10);
  },
  methods:{
    updateReviewInfo(){
      this.customer.status = false
      this.customer.reciveMoneyCodeUrl = null
    },
    onSubmit(customer){
      console.log(customer);
      if (!customer.status && customer.confirmBackCardName != customer.backCardName){
        MessageBox({
          title: '提示',
          message: "两次输入不一致， 请确认",
          showCancelButton: true
        });
      }else{
      addBackCardData(customer).then(res=>{
        if (res.success){
          this.customer = res.data;
          Dialog.alert({
            title: '提示',
            message: '添加修改地址成功',
          }).then(() => {
            this.$router.back();
          });
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
      });
      }
    },
    perviewImage(imgUrl){
      ImagePreview({
        images: [
          imgUrl
        ],
        closeable: true,
      });
    },
    onConfirm(value, index) {
      //Toast(`当前值：${value}, 当前索引：${index}`);
      this.customer.backName = value;
      this.showPicker = false;
    },
    onChange(picker, value, index) {
      //Toast(`当前值：${value}, 当前索引：${index}`);
      this.customer.backName = value;
    },
    onCancel() {
      //Toast('取消');
      this.showPicker = false;
    },
    onAddrConfirm(value, index) {
      //Toast(`当前值：${value}, 当前索引：${index}`);
      this.customer.backOpenAdress = value[0].name+","+value[1].name;
      this.showAddrPicker = false;
    },
    onAddrChange(picker, index, value) {
      //Toast(`当前值：${value}, 当前索引：${index}`);
      let val = picker.getValues();
      console.log(val)//查看打印
      let areaName = ''
      for (var i = 0; i < val.length; i++) {
        areaName = areaName+(i==0?'':'/')+val[i].name
      }
      this.customer.backOpenAdress = areaName;
    },
    onAddrCancel() {
      //Toast('取消');
      this.showAddrPicker = false;
      this.$refs.myArea.reset()// 重置城市列表
    },
    afterImages(file){
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res=>{
        if (res.success){
          file.status = 'success';
          file.message = '上传成功';
          this.customer.reciveMoneyCodeUrl=res.data;
        }
      });
    },
    resetPassword(){
      this.$router.push({path:'/home/resetcustomerpwd'});
    },
  }
}
</script>

<style lang="scss" scoped>

 button{
      width: 280px;
      color: #fff;
      background: linear-gradient(to right, #3333ff, #3392ff);
    }

::v-deep .van-uploader__upload{
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  box-sizing: border-box;
  width: 128px;
  height: 225px;
  margin: 0 8px 8px 0;
  background-color: #f7f8fa;
}

::v-deep .van-uploader__preview-image{
  display: block;
  width: 128px;
  height: 225px;
  overflow: hidden;
}
</style>
